import React, { useState, useEffect } from "react";
import { Container, Row, Col, Button, Breadcrumb } from "react-bootstrap";
import Switch from "react-switch";
import { useDispatch, useSelector } from "react-redux";
import {
  basicSettingDetails,
  getBasicDetails,
} from "../../../../store/actions";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Loading from "../../../../Common/extra/loading";

const BasicSettingIndex = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [state, setState] = useState({
    emailNotification: false,
    SMSNotification: false,
    pushNotification: false,
    smsTime: "",
    emailTime: "",
  });
  const [emailDays, setemailDays] = useState("daily");
  const [smsDays, setsmsDays] = useState("daily");
  const [otherEmailDays, setOtherEmailDays] = useState(1);
  const [otherSMSDays, setOtherSMSDays] = useState(1);

  const SettingsData = useSelector(
    (s) => s?.Setting?.basicSettingDetails?.data?.days
  );

  useEffect(() => {
    dispatch(getBasicDetails());
  }, []);

  useEffect(() => {
    if (SettingsData) {
      setState({
        emailNotification: JSON.parse(SettingsData?.email?.status),
        SMSNotification: JSON.parse(SettingsData?.sms?.status),
        pushNotification: JSON.parse(SettingsData?.push?.status),
        smsTime: SettingsData?.sms?.time,
        emailTime: SettingsData?.email?.time,
      });

      if (
        SettingsData?.email?.status == "true" &&
        SettingsData?.email?.days == 1
      ) {
        setemailDays("daily");
      } else if (
        SettingsData?.email?.status == "true" &&
        SettingsData?.email?.days == 7
      ) {
        setemailDays("weekly");
      } else if (
        SettingsData?.email?.status == "true" &&
        SettingsData?.email?.days == 10
      ) {
        setemailDays("tenDays");
      } else {
        setemailDays("other");
      }

      if (SettingsData?.email?.status == "true") {
        setOtherEmailDays(SettingsData?.email?.days);
      }

      if (SettingsData?.sms?.status == "true" && SettingsData?.sms?.days == 1) {
        setsmsDays("daily");
      } else if (
        SettingsData?.sms?.status == "true" &&
        SettingsData?.sms?.days == 7
      ) {
        setsmsDays("weekly");
      } else if (
        SettingsData?.sms?.status == "true" &&
        SettingsData?.sms?.days == 10
      ) {
        setsmsDays("tenDays");
      } else {
        setsmsDays("other");
      }

      if (SettingsData?.sms?.status == "true") {
        setOtherSMSDays(SettingsData?.sms?.days);
      }
    }
  }, [SettingsData]);

  const handleToggle = (value, name) => {
    setState((pre) => ({ ...pre, [name]: value }));
  };

  const handleEmailNotify = (type, name) => {
    if (type == "email") {
      setemailDays(name);
    } else if (type == "sms") {
      setsmsDays(name);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setState((pre) => ({ ...pre, [name]: value }));
  };

  const handleOtherChange = (e, type) => {
    const { name, value } = e.target;
    if (type == "email") {
      setOtherEmailDays(value);
    } else {
      setOtherSMSDays(value);
    }
  };

  const handleUpdate = (e) => {
    e.preventDefault();
    let emailDay;
    let smsDay;
    setLoading(true);
    const callBack = (res) => {
      setLoading(false);
      if (res.data) {
        toast.success("Success!");
        dispatch(getBasicDetails());
      }
    };

    if (emailDays == "daily") {
      emailDay = 1;
    } else if (emailDays == "weekly") {
      emailDay = 7;
    } else if (emailDays == "tenDays") {
      emailDay = 10;
    } else {
      emailDay = otherEmailDays;
    }

    if (smsDays == "daily") {
      smsDay = 1;
    } else if (smsDays == "weekly") {
      smsDay = 7;
    } else if (smsDays == "tenDays") {
      smsDay = 10;
    } else {
      smsDay = otherSMSDays;
    }

    let body = {
      days: {
        email: {
          days: emailDay,
          time: state.emailTime,
          status: JSON.stringify(state.emailNotification),
        },
        sms: {
          days: smsDay,
          time: state.smsTime,
          status: JSON.stringify(state.SMSNotification),
        },
        push: {
          days: 1,
          status: JSON.stringify(state.pushNotification),
        },
      },
    };

    dispatch(basicSettingDetails(body, callBack));
  };
  return (
    <>
      {loading && <Loading className={"cstmLoader"} />}
      <section className="dashboard py-2">
        <Container>
          <Row>
            <Col lg="12" className="my-2">
              <div className="top mb-2">
                <Breadcrumb>
                  <Breadcrumb.Item>Notification Settings</Breadcrumb.Item>
                </Breadcrumb>
              </div>
            </Col>
            <Col lg="12" className="my-2">
              <div className="bg-white px-4 py-3 card-box rounded">
                <div className="table-responsive py-3">
                  <table className="table common-table">
                    <tbody>
                      <tr>
                        <td>
                          <div className="d-flex">
                            <div className="img-wrp me-2">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="22"
                                height="22"
                                viewBox="0 0 22 22"
                                fill="none"
                              >
                                <path
                                  d="M19.25 17.4167V18.3333H2.75V17.4167L4.58333 15.5833V10.0833C4.58333 7.24167 6.44417 4.73917 9.16667 3.9325V3.66667C9.16667 3.18044 9.35982 2.71412 9.70364 2.3703C10.0475 2.02649 10.5138 1.83333 11 1.83333C11.4862 1.83333 11.9525 2.02649 12.2964 2.3703C12.6402 2.71412 12.8333 3.18044 12.8333 3.66667V3.9325C15.5558 4.73917 17.4167 7.24167 17.4167 10.0833V15.5833L19.25 17.4167ZM12.8333 19.25C12.8333 19.7362 12.6402 20.2025 12.2964 20.5464C11.9525 20.8902 11.4862 21.0833 11 21.0833C10.5138 21.0833 10.0475 20.8902 9.70364 20.5464C9.35982 20.2025 9.16667 19.7362 9.16667 19.25"
                                  fill="#4E4E4E"
                                />
                              </svg>
                            </div>
                            Email Notification{" "}
                          </div>
                        </td>
                        <td>
                          <div className="">
                            <Switch
                              offColor="#888"
                              onColor="#3363df"
                              onChange={(event) =>
                                handleToggle(event, "emailNotification")
                              }
                              checked={state.emailNotification}
                            />
                          </div>
                        </td>
                      </tr>
                      {state.emailNotification && (
                        <>
                          <div className="d-flex basic-setting-table">
                            <div>
                              <input
                                type="checkbox"
                                onChange={() =>
                                  handleEmailNotify("email", "daily")
                                }
                                checked={emailDays == "daily"}
                              />
                              <label htmlFor="">Daily</label>
                            </div>
                            <div>
                              <input
                                type="checkbox"
                                onChange={() =>
                                  handleEmailNotify("email", "weekly")
                                }
                                checked={emailDays == "weekly"}
                              />
                              <label htmlFor="">Weekly</label>
                            </div>
                            <div>
                              <input
                                type="checkbox"
                                onChange={() =>
                                  handleEmailNotify("email", "tenDays")
                                }
                                checked={emailDays == "tenDays"}
                              />
                              <label htmlFor="">Every 10 Days</label>
                            </div>
                            <div>
                              <input
                                type="checkbox"
                                onChange={() =>
                                  handleEmailNotify("email", "other")
                                }
                                checked={emailDays == "other"}
                              />
                              <label htmlFor="">Other</label>
                            </div>
                          </div>

                          {emailDays == "other" && (
                            <div className="num-days">
                              <label htmlFor="">Enter number of days</label>
                              <input
                                type="number"
                                name="days"
                                value={otherEmailDays}
                                onChange={(e) => handleOtherChange(e, "email")}
                              />
                            </div>
                          )}
                          <div className="time-main-div">
                            <label htmlFor="">Select Time to send Email</label>
                            <input
                              type="time"
                              name="emailTime"
                              value={state.emailTime}
                              onChange={handleChange}
                            />
                          </div>
                        </>
                      )}
                      <tr>
                        <td>
                          <div className="d-flex">
                            <div className="img-wrp me-2">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="22"
                                height="22"
                                viewBox="0 0 22 22"
                                fill="none"
                              >
                                <path
                                  d="M19.25 17.4167V18.3333H2.75V17.4167L4.58333 15.5833V10.0833C4.58333 7.24167 6.44417 4.73917 9.16667 3.9325V3.66667C9.16667 3.18044 9.35982 2.71412 9.70364 2.3703C10.0475 2.02649 10.5138 1.83333 11 1.83333C11.4862 1.83333 11.9525 2.02649 12.2964 2.3703C12.6402 2.71412 12.8333 3.18044 12.8333 3.66667V3.9325C15.5558 4.73917 17.4167 7.24167 17.4167 10.0833V15.5833L19.25 17.4167ZM12.8333 19.25C12.8333 19.7362 12.6402 20.2025 12.2964 20.5464C11.9525 20.8902 11.4862 21.0833 11 21.0833C10.5138 21.0833 10.0475 20.8902 9.70364 20.5464C9.35982 20.2025 9.16667 19.7362 9.16667 19.25"
                                  fill="#4E4E4E"
                                />
                              </svg>
                            </div>
                            SMS Notification
                          </div>
                        </td>
                        <td>
                          <div className="">
                            <Switch
                              offColor="#888"
                              onColor="#3363df"
                              onChange={(event) =>
                                handleToggle(event, "SMSNotification")
                              }
                              checked={state.SMSNotification}
                            />
                          </div>
                        </td>
                      </tr>
                      {state.SMSNotification && (
                        <>
                          <div className="d-flex basic-setting-table">
                            <div>
                              <input
                                type="checkbox"
                                onChange={() =>
                                  handleEmailNotify("sms", "daily")
                                }
                                checked={smsDays == "daily"}
                              />
                              <label htmlFor="">Daily</label>
                            </div>
                            <div>
                              <input
                                type="checkbox"
                                onChange={() =>
                                  handleEmailNotify("sms", "weekly")
                                }
                                checked={smsDays == "weekly"}
                              />
                              <label htmlFor="">Weekly</label>
                            </div>
                            <div>
                              <input
                                type="checkbox"
                                onChange={() =>
                                  handleEmailNotify("sms", "tenDays")
                                }
                                checked={smsDays == "tenDays"}
                              />
                              <label htmlFor="">Every 10 Days</label>
                            </div>
                            <div>
                              <input
                                type="checkbox"
                                onChange={() =>
                                  handleEmailNotify("sms", "other")
                                }
                                checked={smsDays == "other"}
                              />
                              <label htmlFor="">Other</label>
                            </div>
                          </div>
                          {smsDays == "other" && (
                            <div className="num-days">
                              <label htmlFor="">Enter number of days</label>
                              <input
                                type="number"
                                name="days"
                                value={otherSMSDays}
                                onChange={(e) => handleOtherChange(e, "sms")}
                              />
                            </div>
                          )}
                          <div className="time-main-div">
                            <label htmlFor="">Select Time to send SMS</label>
                            <input
                              type="time"
                              name="smsTime"
                              value={state.smsTime}
                              onChange={handleChange}
                            />
                          </div>
                        </>
                      )}
                      {/* <tr>
                        <td>
                          <div className="d-flex">
                            <div className="img-wrp me-2">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="22"
                                height="22"
                                viewBox="0 0 22 22"
                                fill="none"
                              >
                                <path
                                  d="M19.25 17.4167V18.3333H2.75V17.4167L4.58333 15.5833V10.0833C4.58333 7.24167 6.44417 4.73917 9.16667 3.9325V3.66667C9.16667 3.18044 9.35982 2.71412 9.70364 2.3703C10.0475 2.02649 10.5138 1.83333 11 1.83333C11.4862 1.83333 11.9525 2.02649 12.2964 2.3703C12.6402 2.71412 12.8333 3.18044 12.8333 3.66667V3.9325C15.5558 4.73917 17.4167 7.24167 17.4167 10.0833V15.5833L19.25 17.4167ZM12.8333 19.25C12.8333 19.7362 12.6402 20.2025 12.2964 20.5464C11.9525 20.8902 11.4862 21.0833 11 21.0833C10.5138 21.0833 10.0475 20.8902 9.70364 20.5464C9.35982 20.2025 9.16667 19.7362 9.16667 19.25"
                                  fill="#4E4E4E"
                                />
                              </svg>
                            </div>
                            Push Notification{" "}
                          </div>
                        </td>
                        <td>
                          <div className="">
                            <Switch
                              offColor="#888"
                              onColor="#3363df"
                              onChange={(event) =>
                                handleToggle(event, "pushNotification")
                              }
                              checked={state.pushNotification}
                            />
                          </div>
                        </td>
                      </tr> */}
                    </tbody>
                  </table>
                </div>
                <Button
                  // disabled={disabled}
                  onClick={handleUpdate}
                  className="d-flex align-items-center justify-content-center"
                >
                  Submit
                </Button>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};
export default BasicSettingIndex;
